import { render, staticRenderFns } from "./SubmissionsDetail.vue?vue&type=template&id=cab84430&scoped=true"
import script from "./SubmissionsDetail.vue?vue&type=script&lang=js"
export * from "./SubmissionsDetail.vue?vue&type=script&lang=js"
import style0 from "./SubmissionsDetail.vue?vue&type=style&index=0&id=cab84430&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cab84430",
  null
  
)

export default component.exports